"use client";

import { cn } from "@gettactic/helpers";
import { Paperclip } from "lucide-react";
import React from "react";

export interface FileDropOverlayProps {
  /** Show the overlay; usually react-dropzone's `isDragActive`. */
  isActive: boolean;
  /** Headline of the drop target. */
  label?: string;
  /** Second line, e.g. the size and count limits. */
  hint?: string;
  className?: string;
}

/**
 * Full-bleed "drop it here" veil for a drop target. Renders nothing until a
 * drag is over the zone, and never takes pointer events — the drop is handled
 * by the container that owns the dropzone root.
 */
export const FileDropOverlay: React.FC<FileDropOverlayProps> = ({
  isActive,
  label = "Drop files to attach",
  hint,
  className
}) => {
  if (!isActive) {
    return null;
  }

  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 z-30 flex items-center justify-center bg-brand/5 backdrop-blur-xs",
        className
      )}
    >
      <div className="flex flex-col items-center gap-2 rounded-brand-xl border-2 border-brand border-dashed bg-white/90 px-8 py-6 shadow-sm">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand/10">
          <Paperclip className="h-5 w-5 text-brand" />
        </span>
        <p className="font-medium text-neutral-900 text-sm">{label}</p>
        {hint ? <p className="text-2xs text-neutral-500">{hint}</p> : null}
      </div>
    </div>
  );
};
